import { useToast } from '@chakra-ui/react';
import { useMutation } from '@tanstack/react-query';
import { adminLoginApi } from 'api/auth.api';
import { setAuth } from 'constants/helper/authStorage';

const getErrorMessage = (error, fallback) => {
  const msg = error?.response?.data?.message;
  if (typeof msg === 'string') return msg;
  if (typeof msg === 'object' && msg?.message) return msg.message;
  return fallback;
};

export const useAdminLogin = () => {
  const toast = useToast();

  return useMutation({
    mutationFn: (payload) => adminLoginApi(payload),

    onSuccess: (res) => {
      const token = res?.data?.token;
      const user = res?.data?.userDetails;

      setAuth({ token, user });

      if (token) {
        localStorage.setItem('token', token);
      }

      toast({
        // title: 'Login successful',
        description: res?.data?.message || 'Welcome back!',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-center',
      });
    },

    onError: (error) => {
      toast({
        title: 'Login failed',
        description: getErrorMessage(error, 'Invalid User ID or Password'),
        status: 'error',
        duration: 4000,
        isClosable: true,
        position: 'top-center',
      });
    },
  });
};
